/**
 * App Configuration for Website
 * Contains store links and metadata for all available apps
 */

export type ExamType = 'telc' | 'dele' | 'leben-in-deutschland';

export interface AppConfig {
  id: string;
  examType: ExamType;
  displayName: string;
  description: string;
  flag: string;
  isAvailable: boolean;
  storeLinks: {
    android: string;
    ios: string;
  };
  packageName: string;
  iosAppId: string;
}

export const appsConfig: AppConfig[] = [
  {
    id: 'leben-in-deutschland',
    examType: 'leben-in-deutschland',
    displayName: 'Leben in Deutschland',
    description: 'German Citizenship Test (Einbürgerungstest) - 300 questions in 8 languages',
    flag: '🇩🇪',
    isAvailable: true,
    storeLinks: {
      android: 'https://play.google.com/store/apps/details?id=com.mhamada.lebenindeutschland',
      ios: 'https://apps.apple.com/us/app/leben-in-deutschland-lid/id6758432061',
    },
    packageName: 'com.mhamada.lebenindeutschland',
    iosAppId: '6758432061',
  },
];

export const getAppByExamType = (examType: ExamType): AppConfig | undefined => {
  return appsConfig.find(app => app.examType === examType);
};

export const getAppById = (id: string): AppConfig | undefined => {
  return appsConfig.find(app => app.id === id);
};

